var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"person"},[React.createElement("rect",{"width":"24","height":"24","opacity":"0","key":0}),React.createElement("path",{"d":"M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4z","key":1}),React.createElement("path",{"d":"M18 21a1 1 0 0 0 1-1 7 7 0 0 0-14 0 1 1 0 0 0 1 1z","key":2})])));
}

User.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = User;

User.default = User;
